import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from "@mui/material";
import { API_URL } from "../consts";
import { SatispayMessaggi } from "./SatispayConsts";
//imports per dialog di confirm
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';

export function Satispay() {
    //const [amount, setAmount] = useState('');
    const [satispayPaymentDetails, setSatispayPaymentDetails] = useState('');
    const [messaggioUlteriore, setMessaggioUlteriore] = useState('');
    const [btnVaiARicarica, setBtnVaiARicarica] = useState(<></>);
    const [btnAnnullaPagamento, setBtnAnnullaPagamento] = useState(<></>);
    const [modalDialogConfirm, setModalDialogConfirm] = useState(<></>);
    const [openDialog, setOpenDialog] = useState(false);
    const [btnVaiASatispay, setBtnVaiASatispay] = useState(<></>);
    const [urlPerRedirect, setUrlPerRedirect] = useState("#");

    console.log("R24: urlPerRedirect: ", urlPerRedirect);

    const verificaDatiPagamento = (oggettoDatiPagamento: Object) => {
        //verifico che l'oggetto non sia nullo
        if (oggettoDatiPagamento === null) {
            console.error("L'oggetto datiPagamento è nullo");
            return false;
        }
        //verifico che contenga le seguenti proprietà
        const prop_da_verificare = ['satispayPaymentId', 'satispaySandBoxMode'];
        for (let i = 0; i < prop_da_verificare.length; i++) {
            try {
                //provo a stampare la proprietà per vedere se esiste
                console.log((oggettoDatiPagamento as any)[prop_da_verificare[i]] as string);
                console.info("L'oggetto datiPagamento contiene la proprietà " + prop_da_verificare[i]);
            } catch (e) {
                console.error("L'oggetto datiPagamento non contiene la proprietà " + prop_da_verificare[i]);
                return false;
            }
            /*if (!oggettoDatiPagamento.hasOwnProperty(prop_da_verificare[i])) {
                console.error("L'oggetto datiPagamento non contiene la proprietà " + prop_da_verificare[i]);
                return false;
            }*/
        }
        return true;
    };

    //let urlPerRedirect = "#";

    /*useEffect(() => {
        
    }, []);*/

    //const [countdown, setCountdown] = useState(120);
    //let creaTimer = true; //
    let aggiornamentoDatiIniziale = true; //se true, aggiorno i dati di pagamento
    //const [countdown, setCountdown] = useState(null);
    //setCountdown(120);

    useEffect(() => {
        const datiRicarica = localStorage.getItem("satispayPaymentDetails");
        if (aggiornamentoDatiIniziale && datiRicarica && datiRicarica !== null) {
            const datiRicaricaObj = JSON.parse(datiRicarica);
            //verifico che datiRicaricaObj sia un oggetto e che contenga le proprietà necessarie
            if ( typeof datiRicaricaObj !== 'object' || !verificaDatiPagamento(datiRicaricaObj)) {
                //console.error("I dati di pagamento non sono validi");
                //return;
                setSatispayPaymentDetails("Non sono stati reperiti dati validi per procedere al pagamento "+datiRicarica);
            } else {
                //setUrlPerRedirect(generaLink(datiRicaricaObj.satispayPaymentId, datiRicaricaObj.satispaySandBoxMode));
                setBtnVaiASatispay(
                <Button id="procediSatispay" variant="contained" color="primary" onClick={handleRicaricaClick}>
                    PROCEDI SU SATISPAY
                </Button>);
                if ( datiRicaricaObj.hasOwnProperty('satispayPayment') ) {
                    const datiRicarica_sp = datiRicaricaObj['satispayPayment'];
                    if ( datiRicarica_sp.hasOwnProperty('satispayResponseData') ) {
                        preparaRiepilogoRicarica(datiRicarica_sp['satispayResponseData']);
                    } else {
                        setSatispayPaymentDetails("Hai una ricarica pendente con id: "+datiRicaricaObj.satispayPaymentId+" completa il pagamento o richiedi una verifica, E92");
                    }
                }
                else if ( datiRicaricaObj.hasOwnProperty('pendingPayments') ) {
                    const pendingPayments = datiRicaricaObj['pendingPayments'];
                    if (pendingPayments.length > 0) {
                        const pendingPayment = pendingPayments[0];
                        console.log("pendingPayment DA REPORTARE: ", pendingPayment);
                        //setSatispayPaymentDetails("pendingPayment DA REPORTARE: "+JSON.stringify(pendingPayment));
                        //costruisco una istanza dell'interfaccia Riepilogo da dare in pasto a preparaRiepilogoRicarica
                        const riepilogoDaPendingPayment = {
                            amount_unit: pendingPayment.amount_unit,
                            status: pendingPayment.status,
                            id: pendingPayment.satispay_id
                        };
                        preparaRiepilogoRicarica(riepilogoDaPendingPayment);
                        datiRicaricaObj.satispayPaymentId = pendingPayment.satispay_id;
                        //preparaRiepilogoRicarica(pendingPayment);
                    } else {
                        setSatispayPaymentDetails("Hai una ricarica pendente con id: "+datiRicaricaObj.satispayPaymentId+" completa il pagamento o richiedi una verifica, E110");
                        console.log(datiRicaricaObj);
                    }
                }
                else {
                    setSatispayPaymentDetails("Hai una ricarica pendente con id: "+datiRicaricaObj.satispayPaymentId+" completa il pagamento o richiedi una verifica, E114");
                    console.info("datiRicaricaObj: ", datiRicaricaObj);
                }
                //preparaRiepilogoRicarica(datiRicaricaObj);
                //const esitoVerifica = handleVerificaClick();
                //setSatispayPaymentDetails("Hai una ricarica pendente con id: "+datiRicaricaObj.satispayPaymentId+" completa il pagamento o richiedi una verifica");
                console.log("dati ricarica in localstorage: ", datiRicarica);
                //importExternalScript(datiRicaricaObj.satispayPaymentId, datiRicaricaObj.satispaySandBoxMode);
                console.log("valore di satispaySandBoxMode: ", datiRicaricaObj.satispaySandBoxMode, " di tipo: ", typeof datiRicaricaObj.satispaySandBoxMode);
                console.log("valore di satispayPaymentId: ", datiRicaricaObj.satispayPaymentId, " di tipo: ", typeof datiRicaricaObj.satispayPaymentId);
                //urlPerRedirect = generaLink(datiRicaricaObj.satispayPaymentId, datiRicaricaObj.satispaySandBoxMode);
                setUrlPerRedirect(generaLink(datiRicaricaObj.satispayPaymentId, datiRicaricaObj.satispaySandBoxMode));
                console.log("urlPerRedirect: ", urlPerRedirect);
            }
            aggiornamentoDatiIniziale = false; //
            console.log("Cambio aggiornamentoDatiIniziale R120: ", aggiornamentoDatiIniziale);
            console.log("datiRicaricaObj R121: ", datiRicaricaObj);
        } else {
            console.error("satispayPaymentDetails non trovato in localStorage");
            if (aggiornamentoDatiIniziale) {
                setSatispayPaymentDetails("Non sono stati reperiti dati validi per procedere al pagamento, ti consigliamo di riprovare");
            } else {
                console.error("aggiornamentoDatiIniziale è false ma mi trovo all'interno del R135");
                if (datiRicarica !== null){
                    const datiRicaricaObj = JSON.parse(datiRicarica);
                    console.info("datiRicaricaObj R137: ", datiRicaricaObj);
                    if (datiRicaricaObj.hasOwnProperty('satispaySandBoxMode') && datiRicaricaObj.hasOwnProperty('satispayPaymentId')) {
                        setUrlPerRedirect(generaLink(datiRicaricaObj.satispayPaymentId, datiRicaricaObj.satispaySandBoxMode));
                    } else {
                        console.error("R136! datiRicaricaObj non contiene satispaySandBoxMode e satispayPaymentId");
                    }
                    setBtnVaiASatispay(
                        <Button id="procediSatispay" variant="contained" color="primary" onClick={handleRicaricaClick}>
                            PROCEDI SU SATISPAY
                        </Button>);
                    console.info("urlPerRedirect R138: ", urlPerRedirect);
                } else {}
            }
        }
    },[]);

    const handleRicaricaClick = () => {
        console.log("R149 Avvio Ricarica con urlPerRedirect: ", urlPerRedirect);
        if (urlPerRedirect === "#") {
            //ricalcolo l'url se ne esiste la possibilità
            const datiRicarica = localStorage.getItem("satispayPaymentDetails");
            if (datiRicarica === null) {
                console.error("R153 Non sono stati reperiti dati validi per procedere al pagamento, ti consigliamo di riprovare");
                return;
            }
            const datiRicaricaObj = JSON.parse(datiRicarica);
            if (datiRicaricaObj.hasOwnProperty('satispaySandBoxMode') && datiRicaricaObj.hasOwnProperty('satispayPaymentId')) {
                window.location.href = generaLink(datiRicaricaObj.satispayPaymentId, datiRicaricaObj.satispaySandBoxMode);
                //console.log("urlPerRedirect R159: ", urlPerRedirect);
            } else {
                console.error("R161! datiRicaricaObj non contiene satispaySandBoxMode e satispayPaymentId");
                return;
            }
        } else {}
        // genero l'href per il redirect
        window.location.href = urlPerRedirect;
        return;
    };

    const handleVerificaClick = () => {
        //al click sostituisci il messaggio con "Verifica in corso..."
        //const satispayPaymentDetailsState = satispayPaymentDetails;
        //setSatispayPaymentDetails(satispayPaymentDetailsState +" ...Verifica in corso...");
        setMessaggioUlteriore("...Verifica in corso...");
        //Logica per verificare lo stato del pagamento
        let messaggioConsole = "Verifica stato pagamento con id satispay: ";
        let satispayPaymentId = "";
        const satispayPaymentDetailsLS = localStorage.getItem("satispayPaymentDetails");
        if (satispayPaymentDetailsLS === null) {
            messaggioConsole += "Errore nel reperimento dei dati del pagamento da localStorage";
            console.error(messaggioConsole);
            return false;
        } else {}
        const satispayPaymentDetails = JSON.parse(satispayPaymentDetailsLS);
        //controllo se è presente l'id del pagamento in localStorage
        if (satispayPaymentDetailsLS === null || !('satispayPaymentId' in satispayPaymentDetails) ) {
            messaggioConsole += "Errore nel reperimento dell'id pagamento";
        } else {
            satispayPaymentId = satispayPaymentDetails['satispayPaymentId'].toString();
            messaggioConsole += satispayPaymentId
        }
        console.log(messaggioConsole);
        //return true;
        //Logica per verificare lo stato del pagamento
        axios.post(API_URL + 'ricarica/satispaycheck', { satispay_id: satispayPaymentId })
            .then(response => {
                console.log("R200 Risposta dal server satispaycheck: ");
                //controllo se in data è presente il verifySatyspayPayment e il relativo status
                if ('verifySatispayPayment' in response.data && 'status' in response.data['verifySatispayPayment']) {
                    const statusPagamentoAPI = response.data['verifySatispayPayment']['status'];
                    console.log("R204 verifySatispayPayment: ", statusPagamentoAPI);
                    switchStatusDiPagamento(statusPagamentoAPI); //esegue le operazioni tipiche dello switch case status pagamento api
                } 
                else {
                    console.error("R208 Errore nella risposta dal server, manca verifySatispayPayment");
                    console.log(response.data);
                }
                //cambiare il valore di satispayPaymentDetails in localStorage
                console.log("Salvo i dati del pagamento in localStorage");
                //localStorage.setItem("satispayPaymentDetails", JSON.stringify(response.data));
                //window.location.reload();
            })
            .catch(error => {
                console.error(error);
                return false;
            });

        return true;
    };

    const handleConfermaAnnullamento = () => {
        const satispayPaymentDetailsLS = localStorage.getItem("satispayPaymentDetails");
        if (satispayPaymentDetailsLS === null) {
            console.error("Errore nel reperimento dei dati del pagamento da localStorage");
            return false;
        } else {}
        const satispayPaymentDetailsObj = JSON.parse(satispayPaymentDetailsLS);
        const satispayPaymentId_dainviare = satispayPaymentDetailsObj['satispayPaymentId'];
        console.log("Richiesta cancellazione al server del pagamento con id: ", satispayPaymentId_dainviare);
        //
        axios.post(API_URL + 'ricarica/satispaycancel', { satispay_id: satispayPaymentId_dainviare })
            .then(response => {
                console.log("Risposta dal server cancellazione: ");
                //controllo se in data è presente il verifySatyspayPayment e il relativo status
                if ('verifySatispayPayment' in response.data && 'status' in response.data['verifySatispayPayment']) {
                    const statusPagamentoAPI = response.data['verifySatispayPayment']['status'];
                    console.log("R240 verifySatispayPayment: ", statusPagamentoAPI);
                    switchStatusDiPagamento(statusPagamentoAPI); //esegue le operazioni tipiche dello switch case status pagamento api
                } else {
                    console.error("R243 Errore nella risposta dal server, manca verifySatispayPayment");
                    console.log(response.data);
                }
                //cambiare il valore di satispayPaymentDetails in localStorage
                console.log("Rimuovo i dati del pagamento in localStorage");
                localStorage.removeItem("satispayPaymentDetails");
                //localStorage.setItem("satispayPaymentDetails", JSON.stringify(response.data));
                //window.location.reload();
                setModalDialogConfirm(<Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                    {SatispayMessaggi.PAGAMENTOANNULLATOTITOLETTO}
                  </Alert>);
                setBtnAnnullaPagamento(<></>);
                setBtnVaiARicarica(<></>);
                setBtnVaiASatispay(<></>)
                setSatispayPaymentDetails(SatispayMessaggi.PAGAMENTOANNULLATOTITOLETTO);
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOANNULLATO);
            })
            .catch(error => {
                console.error(error);
                return false;
            });
        //
        //window.location.href = "/app/gestionePrenotazioni";
        return true;
    };

    const handleAnnullaAnnullamento = () => {
        setModalDialogConfirm(<></>);
        setOpenDialog(false);
        return true;
    };

    const handleAnnullaClick = () => {
        console.log("R268 OpenDialog:",{openDialog});
        console.log("R237 Richiesta di annullamento pagamento");
        setOpenDialog(true);
        console.log("R273 OpenDialog:",{openDialog});
        const apriDialog = true;
        setModalDialogConfirm(
        <Dialog
            open={apriDialog}
            onClose={handleAnnullaAnnullamento}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
                RICHIESTA DI ANNULLAMENTO
            </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {SatispayMessaggi.CONFERMARICHIESTAANNULLAMENTO}
          </DialogContentText>
          </DialogContent>
        <DialogActions>
          <Button onClick={handleAnnullaAnnullamento}>INDIETRO</Button>
          <Button onClick={handleConfermaAnnullamento} autoFocus>
            CONFERMA ANNULLAMENTO
          </Button>
        </DialogActions>
      </Dialog>);
      //setOpenDialog(true);
      return true;
    };

    //const oraPrenotaData = oraPrenotaStore.getState(); // è uno UserState
    //const datiContenutiInUserState = JSON.stringify(oraPrenotaData);
    //leggo dallo store UI i dati che in altra pagina ho salvato mediante uiStore.setSatispayPaymentDetails(datiRicarica);
    //console.log('Dati ricarica: ', satispayPaymentDetails);

    const generaLink = (satispayPaymentId: string, satispaySandBoxMode: boolean) => {
        console.log("Genero link per redirect a partire da satispayPaymentId: ", satispayPaymentId, " e satispaySandBoxMode: ", satispaySandBoxMode);
        let urlDiRitorno = window.location.origin +"/app/ricarica/satispayreturn";//?id="+satispayPaymentId;
        let hrefPerRedirect = "";
        if (typeof satispaySandBoxMode === "boolean" && satispaySandBoxMode !== false) {
            hrefPerRedirect = `https://staging.online.satispay.com/pay/`;
        } else {
            hrefPerRedirect = `https://online.satispay.com/pay/`;
        }
        hrefPerRedirect += satispayPaymentId + "?redirect_url=" + encodeURIComponent(urlDiRitorno);
        console.log("Link generato: ", hrefPerRedirect);
        //setUrlPerRedirect(hrefPerRedirect);
        return hrefPerRedirect;
    };

    const handleTornaRicaricaSatispay = () => {
        window.location.href = "/app/ricarica/satispay";
        return;
    };

    const handleTornaRicaricaForm = () => {
        window.location.href = "/app/ricarica";
        return;
    };

    interface Riepilogo {
        amount_unit: number;
        status: string;
        id: string;
        //scadenza: Date;
        [key: string]: any;
    }

    const switchStatusDiPagamento = (statusDiPagamento: string) => {
        let stato = "SCONOSCIUTO";
        switch (statusDiPagamento) {
            case "PENDING":
                stato = "IN ATTESA"; 
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOPENDENTE);
                setBtnVaiARicarica(<Button id="vaiARicaricaSatispay" variant="contained" color="warning" onClick={handleVerificaClick}>
                    VERIFICA STATUS PAGAMENTO
                  </Button>);
                setBtnAnnullaPagamento(<Button id="annullaPagamento" variant="contained" color="error" onClick={handleAnnullaClick}>ANNULLA RICARICA</Button>);
                break;
            case "ACCEPTED": 
                stato = "COMPLETATO"; 
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOCONFERMATO);
                break;
            case "COMPLETED": 
                stato = "COMPLETATO"; 
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOCONFERMATO);
                break;
            case "EXPIRED": 
                stato = "TERMINI DI PAGAMENTO SCADUTI"; 
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOSCADUTO);
                setBtnVaiARicarica(<Button id="vaiARicarica" variant="contained" color="warning" onClick={handleTornaRicaricaForm}>
                    NUOVA RICARICA
                  </Button>);
                break;
            case "CANCELED": 
                stato = "ANNULLATO";
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOANNULLATO);
                break;
            case "REFUNDED": stato = "RIMBORSATO"; break;
            case "FAILED": stato = "FALLITO"; break;
            default: 
                stato = "SCONOSCIUTO";
                setBtnVaiARicarica(<Button id="verificaSatispay" variant="contained" color="warning" onClick={handleVerificaClick}>
                    VERIFICA
                  </Button>);
                break;
        }
        return stato;
    };
    
    const preparaRiepilogoRicarica = (oggettoRiepilogo: Riepilogo) => {
        const importoRicarica = Math.floor( oggettoRiepilogo["amount_unit"] /100 );
        let stato = "SCONOSCIUTO";
        switch (oggettoRiepilogo.status) {
            case "PENDING": 
                stato = "IN ATTESA"; 
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOPENDENTE);
                setBtnVaiARicarica(<Button id="vaiARicaricaSatispay" variant="contained" color="warning" onClick={handleVerificaClick}>
                    VERIFICA STATUS PAGAMENTO
                  </Button>);
                setBtnAnnullaPagamento(<Button id="annullaPagamento" variant="contained" color="error" onClick={handleAnnullaClick}>ANNULLA RICARICA</Button>);
                break;
            case "COMPLETED": 
                stato = "COMPLETATO"; 
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOCONFERMATO);
                break;
            case "EXPIRED": 
                stato = "TERMINI DI PAGAMENTO SCADUTI"; 
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOSCADUTO);
                setBtnVaiARicarica(<Button id="vaiARicarica" variant="contained" color="warning" onClick={handleTornaRicaricaForm}>
                    NUOVA RICARICA
                  </Button>);
                break;
            case "CANCELED": 
                stato = "ANNULLATO";
                setMessaggioUlteriore(SatispayMessaggi.PAGAMENTOANNULLATO);
                break;
            case "REFUNDED": stato = "RIMBORSATO"; break;
            case "FAILED": stato = "FALLITO"; break;
            default: 
                stato = "SCONOSCIUTO";
                setBtnVaiARicarica(<Button id="verificaSatispay" variant="contained" color="warning" onClick={handleVerificaClick}>
                    VERIFICA
                  </Button>);
                break;
        }
        const textRiepilogoRicarica = `Importo: ${importoRicarica} € | Id Ricarica Satispay: ${oggettoRiepilogo.id} | Stato: ${stato}`;
        setSatispayPaymentDetails(textRiepilogoRicarica);
        return true;
    };

    return (
        <div>
            <h1>Ricarica con Satispay</h1>
            <div id="riepilogoRicarica">
                {/* <p>riepilogo della ricarica che stai effettuando, hai <span id="contoRovescia">{countdown}</span> secondi per completare il pagamento</p> */}
                <p>Riepilogo della ricarica che stai effettuando, ti consigliamo di procedere entro pochi minuti</p>
                <p>Messaggio: {satispayPaymentDetails}</p>
                <p>{messaggioUlteriore}</p>
            </div>
            {/*<Button id="procediSatispay" variant="contained" color="primary" onClick={handleRicaricaClick}>
              PROCEDI SU SATISPAY
            </Button>*/}
            {btnVaiASatispay}
            {btnVaiARicarica}
            {btnAnnullaPagamento}
            {modalDialogConfirm}
        </div>
    );
};
